import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
// import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useState } from "react";
import toRupiah from "../../utils/toRupiah";
import useDetailInvoice from "../../services/queries/useDetailInvoice";
import ModalDetailInvoice from "../ModalDetailInvoice/ModalDetailInvoice";
import ModalRevertInvoice from "../ModalRevertInvoice/ModalRevertInvoice";
import Button from "@mui/material/Button";
import useDetailInvoiceVoid from "../../services/queries/useDetailInvoiceVoid";
import ModalDetailInvoiceVoid from "../ModalDetailInvoice/ModalDetailInvoiceVoid";

interface ICardInvoiceProps {
    detailInvoiceId: number;
    noInvoice: string;
    tanggalInvoice: string;
    hargaPenjualan: number;
    revertId: number | null;
    refetchListInvoice: () => void;
}

const CardInvoice = ({
    detailInvoiceId,
    noInvoice,
    tanggalInvoice,
    hargaPenjualan,
    revertId,
    refetchListInvoice,
}: ICardInvoiceProps) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    const [isOpenModalRevertInvoice, setIsOpenModalRevertInvoice] =
        useState(false);
    const [isOpenModalDetailInvoice, setIsOpenModalDetailInvoice] =
        useState(false);
    const [isOpenModalDetailInvoiceVoid, setIsOpenModalDetailInvoiceVoid] =
        useState(false);
    const { data: detailInvoice, status: statusDetailInvoice } =
        useDetailInvoice(detailInvoiceId);
    const { data: detailInvoiceVoid, status: statusDetailInvoiceVoid } =
        useDetailInvoiceVoid(revertId);

    const closeModalDetailInvoice = () => {
        setIsOpenModalDetailInvoice(false);
    };

    const closeModalDetailInvoiceVoid = () => {
        setIsOpenModalDetailInvoiceVoid(false);
    };

    return (
        <React.Fragment>
            <Card
                variant="outlined"
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 1,
                    padding: isTabletScreen ? 1 : 2,
                }}
            >
                <Box>
                    <Typography fontWeight="bold">{noInvoice}</Typography>
                    <Typography fontSize={12} color="#76747C">
                        {tanggalInvoice}
                    </Typography>
                    <Typography
                        marginTop={1}
                        fontSize={12}
                        fontWeight="bold"
                        color="#76747C"
                    >
                        {revertId !== null
                            ? "Pembayaran dibatalkan"
                            : hargaPenjualan < 0
                            ? "Laporan pembatalan"
                            : `Tunai: ${toRupiah(hargaPenjualan)}`}
                    </Typography>
                </Box>
                <Stack direction="row" spacing={2}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            if (revertId !== null) {
                                setIsOpenModalDetailInvoiceVoid(true);
                            } else {
                                setIsOpenModalDetailInvoice(true);
                            }
                        }}
                        size="small"
                        color="buttongreen"
                        disableElevation
                        sx={{
                            minWidth: "unset",
                            padding: "8px",
                            width: "32px",
                            height: "32px",
                        }}
                    >
                        <VisibilityIcon
                            sx={{ width: "16px", height: "16px" }}
                        />
                    </Button>
                </Stack>
            </Card>
            {detailInvoice && (
                <ModalDetailInvoice
                    fullScreen={fullScreen}
                    isOpenModalDetailInvoice={isOpenModalDetailInvoice}
                    statusDetailInvoice={statusDetailInvoice}
                    closeModalDetailInvoice={closeModalDetailInvoice}
                    data={detailInvoice}
                />
            )}
            {detailInvoiceVoid && (
                <ModalDetailInvoiceVoid
                    fullScreen={fullScreen}
                    isOpenModalDetailInvoiceVoid={isOpenModalDetailInvoiceVoid}
                    statusDetailInvoiceVoid={statusDetailInvoiceVoid}
                    closeModalDetailInvoiceVoid={closeModalDetailInvoiceVoid}
                    data={detailInvoiceVoid}
                />
            )}
            <ModalRevertInvoice
                diskon={Number(detailInvoice?.diskon)}
                totalHarga={Number(detailInvoice?.hargaAsli)}
                totalTagihan={Number(detailInvoice?.totalPembayaran)}
                uangDibayar={Number(detailInvoice?.uangYangDibayar)}
                kembalian={Number(detailInvoice?.kembalian)}
                refetchLaporan={() => {}}
                refetchListInvoice={refetchListInvoice}
                refetchProdukTerjual={() => {}}
                refetchMutasiStok={() => {}}
                refetchGrafikPenjualan={() => {}}
                item={detailInvoice?.daftarStok}
                statusItem={statusDetailInvoice}
                invoiceId={detailInvoiceId}
                isOpenModalRevertInvoice={isOpenModalRevertInvoice}
                closeModalRevertInvoice={() =>
                    setIsOpenModalRevertInvoice(false)
                }
            />
        </React.Fragment>
    );
};

export default CardInvoice;
